import React from 'react';
import { CenteredContentLayout } from 'components/containers/CenteredContentLayout';
import { Panel } from 'components/containers/Panel';
import { useGetAdminUsersQuery } from '../../../../models/graphql';
import { Button } from '../../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { setImpersonationUid } from '../../../../helpers/impersonationHelpers';
import { remapApolloErrors } from '../../../../helpers/remapApolloErrors';
import { Table } from '../../../../components/containers/Table';
import { Tooltip } from '../../../../components/actions/Tooltip';
export const AdminUsers = (): JSX.Element => {
  const { error, loading, data } = useGetAdminUsersQuery();
  const hasError = typeof error !== 'undefined';
  const users = data?.admin_users;

  const onImpersonate = (userId: string) => {
    setImpersonationUid(userId);
    window.location.assign('/');
  };

  return (
    <CenteredContentLayout headerTitle={'[Admin] - User List'} loading={loading} hasSidebar={true} wider>
      <Panel>
        {hasError && (
          <p>
            Sorry, an error occured: <strong>{remapApolloErrors(error)}</strong>
          </p>
        )}
        {users && (
          <Table tableStyle={'basic'}>
            <>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>App Role</th>
                  <th>
                    In Overhaul{' '}
                    <Tooltip pointer target={`#tooltip-in-overhaul`} type={'inlined'}>
                      <>
                        <p>
                          If the user is currently in the overhaul. For example, a legacy Member may have been migrated
                          to the overhaul which creates a User, but then rolled back to legacy. Another example is if
                          the user joined the overhaul without coming from the legacy product.
                        </p>
                        <p>You can only impersonate users that are currently in the overhaul.</p>
                      </>
                    </Tooltip>
                  </th>
                  <th>Signup Method</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.firstName}</td>
                    <td>{user.email}</td>
                    <td>{user.appRole}</td>
                    <td>{!user.fromLegacy || user.migratedToOverhaul ? 'Yes' : 'No'}</td>
                    <td>{user.migratedToOverhaul ? 'Legacy' : 'Overhaul'}</td>
                    <td>
                      {(!user.fromLegacy || user.migratedToOverhaul) && (
                        <Button
                          type={'button'}
                          variant={'hollow'}
                          size={'small'}
                          color={ButtonColorsEnum.primary}
                          action={() => onImpersonate(user.id)}>
                          Impersonate
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </>
          </Table>
        )}
      </Panel>
    </CenteredContentLayout>
  );
};
